import type { FC, ReactNode } from "react";
import { createContext, useContext } from "react";

import type { OpenCatalogInitialProps } from "@shared/types/openCatalogInitialProps";
import { getInitialProps } from "@shared/utils/getInitialProps";

const InitialPropsContext = createContext<OpenCatalogInitialProps>(null);

interface Props {
  initialProps: OpenCatalogInitialProps;
}

const useInitialProps = (): OpenCatalogInitialProps => {
  const initialProps: OpenCatalogInitialProps = useContext(InitialPropsContext);
  return initialProps;
};

interface Props {
  children: ReactNode;
}

const InitialPropsProvider: FC<Props> = ({ children, initialProps }) => {
  return (
    <InitialPropsContext.Provider value={initialProps || getInitialProps()}>
      {children}
    </InitialPropsContext.Provider>
  );
};

export { InitialPropsContext, InitialPropsProvider, useInitialProps };
